import $ from 'jquery';

import { sprintf } from '@wordpress/i18n';

import Tokens from './index.js';

import { parseDynamicSentence } from '@builder-legacy/utilities';

import {
	openInNewTab,
	recipeSetRequiresUser
} from '../common/utilities';

// Import utilities
const {
	isDefined,
	isEmpty,
	debounce,
	throttle,
	addParametersUTM
} = _uo.utility;

import Modal from '../common/modal';

import Field from '../field';

export default class TokenSelector {
	constructor( Field, options = {} ){
		// Check if the field supports tokens
		if ( Field.attributes.supportsTokens ){
			// Create different Tokens Selectors depending on the field type
			if ( Field.type == 'textarea' ){
				return new TokenSelectorTextarea( Field, options );
			}
			else {
				return new TokenSelectorInput( Field, options );
			}
		}
	}
}

class TokenSelectorInput extends Tokens {
	constructor( Field, options = {} ){
		super(
			Field.attributes.itemType,
			Field.type,
			options
		);

		// Save field
		this.Field = Field;

		// Save the Token Selector instance in the field
		this.Field.TokenSelector = this;

		// Check if the field is inside a user loop
		this.itemIsInsideUserLoop = UncannyAutomator._core.recipe.item.loop.isItemInsideUserLoop( this.Field.attributes.itemId || 0 );

		// Render the token selector
		this.render();

		// Set data
		this.setData();

		// CodeMirror methods
		this.Field.getField().on( 'ua-codemirror-ready', () => {
			// Get the CodeMirror editor
			this.getCodeMirrorEditor();

			// Render tokens right away, without the delay
			this.editor.setValue( this.editor.getValue() );
			this.renderTokens();

			// Handle requests to add tokens to the field
			this.handleAddTokens();

			// Render tokens in real time
			this.renderTokensInRealTime();
		}); 
	}

	render(){
		this.RenderTokenSelector = new RenderTokenSelector( this.Field, this.tokens );
	}

	setData(){
		this.data = {
			tokenRenderingDebounce: 200,
			// cachedCMWidgets: []
		}
	}

	getCodeMirrorEditor(){
		this.editor = this.Field.fieldCM;
	}

	handleAddTokens(){
		// Listen events that are trying to add a token
		this.Field.field
			.off( 'ua-add-token' )
			.on( 'ua-add-token', ( event, token ) => {
				// Check if it's a date or time field
				if ( [ 'date', 'time' ].includes( this.Field.attributes.fieldType ) ){
					// Remove the value of the field
					this.editor.setValue( '' );
				}

				// Add it to the editor
				this.insertTextAtCursor( `{{${ token.id }}}` );

				// Render tokens right away, without the delay
				this.renderTokens({
					ignoreRequiresUserModal: true
				});

				// Check if it's NOT a date or time field
				if ( ! [ 'date', 'time' ].includes( this.Field.attributes.fieldType ) ){
					// Focus the field again
					this.editor.focus();
				}

				 // Check if it's a date or time field
				if ( [ 'date', 'time' ].includes( this.Field.attributes.fieldType ) ){
					// Set value in the real field
					this.Field.setValue( `{{${ token.id }}}` );
				}
			});
	}

	destroy(){
		// Destroy wrapper
		this.RenderTokenSelector.destroy();
	}

	/**
	 * Insert content in the CM field at the current position
	 *
	 * @since 3.0
	 * 
	 * @param  String   text The content to be added
	 */
	insertTextAtCursor( text ){
		this.editor.doc.replaceRange( text, this.editor.doc.getCursor() );
	}

	renderTokensInRealTime(){
		this.editor.on( 'changes', debounce( ( event ) => {
			// Render tokens
			this.renderTokens();
		}, this.data.tokenRenderingDebounce ) );
	}

	renderTokens( options ){
		// Clear all the current widgets
		// this.data.cachedCMWidgets.forEach( marker => marker.clear() );
		// this.data.cachedCMWidgets = [];

		// Get the options
		options = Object.assign({
			ignoreRequiresUserModal: false,
		}, options );

		// Search tokens
		const querySearchTokens = this.editor.getSearchCursor( /\{\{(.*?)\}\}/ );

		// Iterate them
		while ( querySearchTokens.findNext() ){
			// Get position
			const position = {
				from: querySearchTokens.from(),
				to:   querySearchTokens.to()
			}

			// Get the content
			const content = this.editor.getRange(
				position.from,
				position.to
			);

			// Remove the opening and closing brackets
			const tokenId = content.replace( '{{', '' ).replace( '}}', '' );
			
			// Get the token HMTL
			const $tokenNode = this.createTokenDOMNode( tokenId );

			// Create CodeMirror widget
			const widget = this.editor.markText( 
				position.from,
				position.to,
				{
					replacedWith: $tokenNode
				}
			);

			if (
				( ! this.itemIsInsideUserLoop ) && 

				// Check if the recipe is anonymous
				UncannyAutomator._recipe.recipe_type == 'anonymous'
				// Check if the recipe currently doesn't require user data
				&& ! UncannyAutomator.recipe.requiresUserData
				&& (
					// Check if the current tokens requires user data
					this.tokensThatRequireUser.includes( tokenId )
					// Check if it's the user meta token
					|| tokenId.startsWith( 'USERMETA:' )
				)
				// Check if we have to ignore the requires user modal
				&& ! options.ignoreRequiresUserModal
			){
				this.tokenNeedsUserModal( $tokenNode, {
					// Create function to remove the current token
					removeToken: () => {
						// Get the widget position
						const widgetPosition = widget.find();

						// Remove the widget
						widget.clear();

						// Remove the token content
						this.editor.replaceRange(
							'',
							widgetPosition.from,
							widgetPosition.to
						);
					}
				});

				// Stop the loop
				break;
			}

			// Add events to the tokens, but only if the field is not read only
			if ( ! this.Field.attributes.isReadOnly ){
				// Select on click
				$tokenNode.addEventListener( 'click', () => {
					// Check if it's focus
					if ( ! $tokenNode.classList.contains( 'uap-token--cm-focused' ) ){
						// Add focus class
						$tokenNode.classList.add( 'uap-token--cm-focused' );

						const onFocusOut = () => {
							// Remove focus class
							$tokenNode.classList.remove( 'uap-token--cm-focused' );

							// Remove the event listener that listen clicks
							// outside the token
							document.removeEventListener( 'mouseup', onClickOutside );

							// Remove the event listener to copy to the
							// token to the clipboard
							document.removeEventListener( 'copy', onCopy );

							// Remove the event listener to remove the token
							document.removeEventListener( 'keydown', onDelete );

							// Remove the event listener to move the cursor
							// to the left or right using the direction keys
							document.removeEventListener( 'keydown', onNavigation );
						}

						// Listen clicks outside
						const onClickOutside = ( event ) => {
							if (
								// Check if the clicked element is not the token
								! ( $tokenNode === event.target )
								// And check if the clicked element is NOT a child
								// of the token
								&& ! ( $tokenNode.contains( event.target ) )
							){
								onFocusOut();
							}
						};
						document.addEventListener( 'mouseup', onClickOutside );

						// Listen copy event
						const onCopy = ( event ) => {
							onFocusOut();

							// Copy the token ID
							try {
								navigator.clipboard.writeText( `{{${ tokenId }}}` );
							} catch ( e ) {
								// Output error if the developer mode is enabled
								if ( UncannyAutomator._site.has_debug_enabled ){
									// eslint-disable-next-line no-console
									console.warn( e );
								}
							}
						};
						document.addEventListener( 'copy', onCopy );

						// Listen delete event
						const onDelete = ( event ) => {
							// Get the pressed key
							const key = event.keyCode || event.charCode;

							// Check if it's the "backspace" or "del" key
							if ( key == 8 || key == 46 ){
								// Get the widget position
								const widgetPosition = widget.find();

								// Remove the widget
								widget.clear();

								// Remove the token content
								this.editor.replaceRange(
									'',
									widgetPosition.from,
									widgetPosition.to
								);

								onFocusOut();
							}
						}
						document.addEventListener( 'keydown', onDelete );

						// Listen navigation events
						const onNavigation = ( event ) => {
							// Get the pressed key
							const key = event.keyCode || event.charCode;

							// Check if it's one of the <- or -> keys
							if ( key == 37 || key == 39 ){
								onFocusOut();

								// Get the widget position
								const widgetPosition = widget.find();

								// Get the new position
								let position;

								// Check if it's the "<-" (left) key
								if ( key == 37 ){
									// Get the left position
									position = widgetPosition.from;
								}

								// Check if it's the "->" (right) key
								if ( key == 39 ){
									// Get the right position
									position = widgetPosition.to;
								}

								// Set focus
								this.editor.focus();

								// Set the cursor
								this.editor.setCursor( position )
							}
						}
						document.addEventListener( 'keydown', onNavigation );
					}
				});
			}  
		}
	}

	/**
	 * Shows modal to tell the user that the token added needs user data
	 * 
	 * @param  {Object} token     The token added
	 * @param  {Object} callbacks Object with callbacks
	 */
	tokenNeedsUserModal( $tokenNode, callbacks = {} ){
		/**
		 * Create modal to ley the user know that
		 * they will need user data
		 */
		let modal;

		// Check if WP is ready
		if ( ! UncannyAutomator._site.automator.has_pro ){
			modal = new Modal({
				title:   `${ UncannyAutomator._core.i18n.userSelector.userDataModal.action.forbidden.title } <span class="needs-user-data-modal-pro-badge">${ UncannyAutomator._core.i18n.proOnly.pro }</span>`,
				content: `
					<div class="needs-user-data-modal">
						<div class="needs-user-data-modal__title">${ 
							sprintf( 
								UncannyAutomator._core.i18n.userSelector.userDataModal.token.forbidden.content.mustRunOnUser,
								$tokenNode.outerHTML
							)
						}</div>
						<div class="needs-user-data-modal__disclaimer">
							<p>
								<div class="description">${ sprintf( UncannyAutomator._core.i18n.userSelector.userDataModal.token.forbidden.content.description, UncannyAutomator._core.i18n.uncannyAutomatorPro ) } <a href="${ addParametersUTM( 'https://automatorplugin.com/pricing/', { 'medium': 'select_an_item', 'campaign': 'update_to_pro', 'content': 'requires_user_data',
							}) }" target="_blank">${ UncannyAutomator._core.i18n.upgradeNow } <uo-icon id="external-link"></uo-icon></a></div>
							</p>
							<p>
								<div class="description">${ UncannyAutomator._core.i18n.userSelector.userDataModal.token.forbidden.content.upgradeLater } <a href="${ addParametersUTM( 'https://automatorplugin.com/knowledge-base/creating-a-recipe/#Recipe_types', { 'medium': 'select_an_item', 'content': 'requires_user_data-learn-more',
							}) }" target="_blank">${ UncannyAutomator._core.i18n.learnMore } <uo-icon id="external-link"></uo-icon></a></div>
							</p>
						</div>
					</div>
				`,
				buttons: {
					cancel:  UncannyAutomator._core.i18n.userSelector.userDataModal.token.forbidden.cancelButton,
					confirm: UncannyAutomator._core.i18n.userSelector.userDataModal.token.forbidden.confirmButton,
				}
			}, {
				size: 'large'
			});

			modal.setEvents({
				onConfirm: () => {
					// Close and destroy modal
					modal.destroy();

					// Open link in new tab
					openInNewTab( addParametersUTM( 'https://automatorplugin.com/pricing/', { 'medium': 'add_token', 'campaign': 'update_to_pro', 'content': 'requires_user_data',
							}) );

					// Remove token
					if ( isDefined( callbacks.removeToken ) ){
						callbacks.removeToken();
					}

					// Can't add, confirm
					if ( isDefined( callbacks.forbiddenConfirm ) ){
						callbacks.forbiddenConfirm();
					}
				},
				onCancel: () => {
					// Close and destroy modal
					modal.destroy();

					// Remove token
					if ( isDefined( callbacks.removeToken ) ){
						callbacks.removeToken();
					}

					// Can't add, cancel
					if ( isDefined( callbacks.forbiddenCancel ) ){
						callbacks.forbiddenCancel();
					}
				},
			});
		}
		else {
			// Check if we should set the recipe to draft when the user adds the action
			// We're doing this because the user will need to fill the User Selector
			const actionWillSetRecipeToDraft = UncannyAutomator._recipe.is_recipe_on;

			modal = new Modal({
				title:   `${ UncannyAutomator._core.i18n.userSelector.userDataModal.action.allowed.title } <span class="needs-user-data-modal-pro-badge needs-user-data-modal-pro-badge--gray">${ UncannyAutomator._core.i18n.proOnly.pro }</span>`,
				content: `
					<div class="needs-user-data-modal">
						<div class="needs-user-data-modal__title">${
							sprintf( 
								UncannyAutomator._core.i18n.userSelector.userDataModal.token.allowed.content.mustRunOnUser,
								$tokenNode.outerHTML
							)
						}</div>
						<div class="needs-user-data-modal__disclaimer">
							<div class="description">${ UncannyAutomator._core.i18n.userSelector.userDataModal.token.allowed.content.description }</div>
						</div>
					</div>
				`,
				buttons: {
					cancel:  UncannyAutomator._core.i18n.userSelector.userDataModal.token.allowed.cancelButton,
					confirm: UncannyAutomator._core.i18n.userSelector.userDataModal.token.allowed.confirmButton,
				},
			}, {
				size: 'large',
			});

			modal.setEvents({
				onConfirm: () => {
					let modalElements = modal.getElements();

					// Add loading class to button
					modalElements.modal.box.buttons.confirm.addClass( 'uap-btn--loading' ).prop( 'disabled', true );

					// Do an AJAX call to set the global recipe requires user
					recipeSetRequiresUser(
						// Set to true (requires user)
						true,
						// On success
						( response ) => {
							// On success, close and destroy the modal
							modal.destroy();

							// Render the tokens again, some might be missing
							this.renderTokens();
						},
						// On fail
						( response ) => {
							// Remove loading class to button
							modalElements.modal.box.buttons.confirm.removeClass( 'uap-btn--loading' ).prop( 'disabled', false );
						}
					);

					// Do a call to set the recipe to draft
					if ( actionWillSetRecipeToDraft ){
						UncannyAutomator.recipe.publish.statusToggle.setValue( false );
					}

					// Can add, confirm
					if ( isDefined( callbacks.allowedConfirm ) ){
						callbacks.allowedConfirm();
					}
				},
				onCancel: () => {
					// Close and destroy modal
					modal.destroy();

					// Remove token
					if ( isDefined( callbacks.removeToken ) ){
						callbacks.removeToken();
					}

					 // Can add, confirm
					if ( isDefined( callbacks.allowedCancel ) ){
						callbacks.allowedCancel();
					}
				},
			});
		}
	}
}

class TokenSelectorTextarea extends TokenSelectorInput {
	constructor( Field, options = {} ){
		super( Field, options );

		// Check if it supports TinyMCE
		if ( this.Field.attributes.supportsTinyMCE ){
			// TinyMCE methods
			this.Field.getField().on( 'ua-tinymce-ready', () => {
				// Get the CodeMirror editor
				this.getTinyMCEEditor();

				// Add styles to the editor
				this.addStylesToEditor();

				// Parse tokens in the TinyMCE editor
				setTimeout(() => {
					this.parsePlainTokensInTinyMCE({
						parseTokensInAttributes: false
					});
				}, this.data.tokenRenderingDebounce );

				// Parse tokens in the text editor
				setTimeout(() => {
					this.parseHTMLTokensInPlainTextarea();
				}, this.data.tokenRenderingDebounce );
				
				// Handle requests to add tokens to the field
				this.handleAddTokens();

				// Handle tokens added to the textarea (HTML)
				this.handleHTMLTokensInPlainTextarea();

				// Handle tokens added to TinyMCE (plain)
				this.handlePlainTokensInTinyMCE();
			});
		}
	}

	setData(){
		this.data = {
			tokenRenderingDebounce: 200,
			tokenCSSClass: 'uap-token-tinymce',
			// Regular expression (lazy) used to find tokens in the raw TinyMCE content
			tinymceTokenRegex: new RegExp( /\<ins contenteditable\="false"\>\<\!\-\-UAToken\-\-\>(?:.*?)data\-token\-id\="(.*?)"(?:.*?)\<\!\-\-UATokenEnd\-\-\>\<\/ins\>/gm ),
		}

		// 1. Token HTML, 2. Token ID
		this.data.tinymceTokenTemplate = `<ins contenteditable="false"><!--UAToken--><span class="${ this.data.tokenCSSClass }" contenteditable="false" data-token-id="%2$s">%1$s</span><!--UATokenEnd--></ins>`;
	}

	render(){
		this.RenderTokenSelector = new RenderTokenSelector( this.Field, this.tokens );
	}

	insertTextAtCursor( token = '' ){
		// Check if "Text" view is selected
		// Insert using CodeMirror methods
		if (
			// Doesn't have TinyMCE
			! isDefined( this.tinyMCEeditor )
			// It has TinyMCE, but it's hidden
			|| isDefined( this.tinyMCEeditor ) && this.tinyMCEeditor.hidden
		){
			// Insert content in the CM field at the current position
			this.editor.doc.replaceRange( token, this.editor.doc.getCursor() );
		}
		// Insert using TinyMCE methods
		else {
			// Token without brackets
			token = token.replace( '{{', '' ).replace( '}}', '' );

			// Get the token HMTL
			const $tokenNode = this.createTokenDOMNode( token );

			// Check if the token needs user data
			// Because of how TinyMCE works, we have to do this here
			if (
				( ! this.itemIsInsideUserLoop ) && 

				// Check if the recipe is anonymous
				UncannyAutomator._recipe.recipe_type == 'anonymous'
				// Check if the recipe currently doesn't require user data
				&& ! UncannyAutomator.recipe.requiresUserData
				// Check if the current tokens requires user data
				&& (
					// Check if the current tokens requires user data
					this.tokensThatRequireUser.includes( token )
					// Check if it's the user meta token
					|| token.startsWith( 'USERMETA:' )
				)
			){
				this.tokenNeedsUserModal( $tokenNode, {
					allowedConfirm: () => {
						// Insert token
						this.tinyMCEeditor.execCommand( 'mceInsertContent', false, sprintf( this.data.tinymceTokenTemplate, $tokenNode.outerHTML, token ) );

						// Trigger a change event in the field
						this.Field.getField()
							.trigger( 'change input' );
						}
				});
			}
			else {
				// Insert token
				this.tinyMCEeditor.execCommand( 'mceInsertContent', false, sprintf( this.data.tinymceTokenTemplate, $tokenNode.outerHTML, token ) );

				// Trigger a change event in the field
				this.Field.getField()
					.trigger( 'change input' );
			} 
		}
	}

	getTinyMCEEditor(){
		this.tinyMCEeditor = this.Field.fieldTinyMCE;
	}

	addStylesToEditor(){
		this.tinyMCEeditor.dom.addStyle( `
			html body {
				font-family: -apple-system, system-ui, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
				font-size: 15px;
				margin-left: 12px;
				margin-right: 12px;
			}

			ins {
				text-decoration: none !important;
			}
		` );
	}

	handleHTMLTokensInPlainTextarea(){
		// Listen changes to the field
		this.Field.getField()
			.on( 'change input',
				debounce(() => {
					// Parse tokens
					this.parseHTMLTokensInPlainTextarea();
				}, this.data.tokenRenderingDebounce )
			);

		// Trigger a change event in the text field 
		// when the user changes to the "Text" tab
		this.Field.getField()
			.on( 'ua-tinymce-activate-text-view', () => {
				// Parse tokens
				setTimeout(() => {
					this.parseHTMLTokensInPlainTextarea();
				}, this.data.tokenRenderingDebounce );
			});
	}

	handlePlainTokensInTinyMCE(){
		// Trigger a change event in the text field 
		// when the user changes to the "Text" tab
		this.Field.getField()
			.on( 'ua-tinymce-activate-visual-view', () => {
				// Parse tokens in the editor
				setTimeout(() => {
					this.parsePlainTokensInTinyMCE({
						parseTokensInAttributes: false
					});
				}, this.data.tokenRenderingDebounce );
			});
	}

	parsePlainTokensInTinyMCE( options = {} ){
		// Get options
		options = Object.assign( {
			parseTokensInAttributes: true
		}, options );

		// Get the content of the TinyMCE field
		const editorContent = this.tinyMCEeditor.getContent({
			format: 'raw'
		});

		// Render the tokens
		const editorContentWithTokens = this.renderTextWithTokens(
			editorContent,
			{
				// 1. Token HTML, 2. Token ID
				template: this.data.tinymceTokenTemplate,
				parseTokensInAttributes: options.parseTokensInAttributes,
				returnString: true
			}
		);

		// Check if the content is different
		if ( editorContent != editorContentWithTokens ){
			// Set the content again
			this.tinyMCEeditor.setContent( editorContentWithTokens );
		}   
	}

	parseHTMLTokensInPlainTextarea(){
		// Get the content of the field
		let content = this.Field.getField().val();

		// Create a variable to check later if the content changed
		let contentChanged = false;

		// Convert TinyMCE tokens to real tokens
		content = content.replaceAll( this.data.tinymceTokenRegex, ( match, tokenID ) => {
			// If this code is reached, it means the content changed
			contentChanged = true;

			// Replace it with a valid token
			return `{{${ tokenID }}}`;
		} );

		// ⤵️ If the content hasn't changed, stop here
		if ( ! contentChanged ) {
			return;
		}

		// Set the value of the normal field
		// But don't trigger the change event
		try {
			this.editor.setValue( content );
		} catch ( e ){
			this.Field.getField().val( content );
		} 
	}

	destroy(){
		this.RenderTokenSelector.destroy();
	}
}

class RenderTokenSelector {
	constructor( Field, tokens ){
		this.Field  = Field;
		this.tokens = tokens;

		// If we're rendering this token selector for an item, get the item information
		this.item = isDefined( this.Field.attributes.itemId ) ? UncannyAutomator._core.recipe.item.getItem( this.Field.attributes.itemType, this.Field.attributes.itemId ) : null;

		// Check if the item is inside a user loop
		this.itemIsInsideUserLoop = UncannyAutomator._core.recipe.item.loop.isItemInsideUserLoop( this.Field.attributes.itemId || 0 );
		
		/**
		 * We have to filter the tokens to make sure we're not rendering tokens coming from actions inside loops
		 */
		this.tokens = this.tokens.filter( tokenGroup => {
			// Check if it's a group of tokens coming from an action
			if ( isDefined( tokenGroup.itemID ) && tokenGroup.itemType === 'action' ) {
				// Get the item that belongs to this token group
				const tokenGroupItem = UncannyAutomator._core.recipe.item.getItem( 
					tokenGroup.itemType, 
					tokenGroup.itemID
				);

				if ( 
					// Check if the item is defined
					isDefined( tokenGroupItem ) && 
					// Check if it has a parent ID
					isDefined( tokenGroupItem.miscellaneous.parent_id ) && 
					// And check if it's inside a loop
					tokenGroupItem.miscellaneous.parent_id !== UncannyAutomator._recipe.recipe_id
				){
					// If we're NOT rendering this token selector for an item, then we shouldn't show tokens 
					// coming from actions inside loops. Stop here
					if ( 
						! isDefined( this.item ) || 
						! isDefined( this.item.miscellaneous ) || 
						! isDefined( this.item.miscellaneous.parent_id ) 
					) {
						return false;
					}

					// As this token group is coming from an action that it's inside a loop, we have to make sure
					// that we're including it only if the item we're rendering the token selector on is also
					// inside the same loop
					if ( this.item.miscellaneous.parent_id !== tokenGroupItem.miscellaneous.parent_id ) {
						return false;
					}
				}
			}
			
			return true;
		} ); 

		/**
		 * Save order of groups
		 */
		this.tokens = this.tokens.map( ( tokenGroup, index ) => {
			tokenGroup.order = index;

			return tokenGroup;
		} );

		// Get data
		this.getData();

		// Get elements
		this.getElements();

		// Create wrapper
		this.createWrapper();

		// Create filter
		this.createFilter();

		// Create groups of tokens
		this.createGroupsOfTokens();

		// Open tokens on click
		this.listenToggleButton();

		// Resize dropdown on window resize
		this.resizeDropdownOnWindowResize();

		// Resize on scroll
		this.resizeDropdownOnWindowScroll();

		// Refresh when the field value changes
		this.refreshOnFieldChange();

		// Search
		this.search();

		// Set default filter
		if ( this.shouldSupportFilters() ){
			this.setFilter( true );
		}
	}

	getData(){
		this.data = {
			isOpen:   false,
			position: 'below'
		}
	}

	getElements(){
		this.$elements = {
			wrapper: null,
			toggleButton: null,
			searchField: null,
			dropdown: null,
			allGroups: null,
			dropdownGroupsContainer: null,
			dropdownTokens: null,
			noResultsOption: null,
			seperators: null,
		};
	}

	createWrapper(){
		const $wrapper = $( `
			<div class="form-variable">
				<div class="form-variable__element">
					<div class="form-variable__render-container"></div>
					<div class="form-variable__toggle">
						<uo-icon id="asterisk"></uo-icon>
					</div>
				</div>
				<div class="form-variable__dropdown">
					<div class="form-variable__dropdown-container">
						<div class="form-variable__search">
							<input 
								class="form-variable__search-input" 
								placeholder="${ UncannyAutomator._core.i18n.tokens.search }"
							>
						</div>
						<div class="form-variable__groups"></div>
					</div>
				</div>
			</div>
		` );

		// Get the fields that we have to move
		const $fieldsToMove = [];

		// Check if it's a textarea
		if ( this.Field.type == 'textarea' ){
			$fieldsToMove.push( this.Field.getField() );
		}

		// Check if the CodeMirror field is defined
		if ( isDefined( this.Field.getFieldCM() ) ){
			$fieldsToMove.push( this.Field.getFieldCM() );
		}

		// Move the fields
		$fieldsToMove.forEach(( $field ) => {
			// Move the field
			$wrapper
				.insertAfter( $field );

			$wrapper
				.find( '.form-variable__render-container' )
				.append( $field );
		});

		// Save the element
		this.$elements.wrapper = $wrapper;

		// Save the element that has the field inside
		this.$elements.renderContainer = $wrapper
			.find( '.form-variable__render-container' );

		// Save the search field container
		this.$elements.searchFieldContainer = $wrapper.find( '.form-variable__search' );

		// Save the search field
		this.$elements.searchField = $wrapper.find( '.form-variable__search-input' );

		// Save the toggle button
		this.$elements.toggleButton = $wrapper.find( '.form-variable__toggle' );

		// Save the dropdown
		this.$elements.dropdown = $wrapper.find( '.form-variable__dropdown' );

		// Save the container of the groups
		this.$elements.dropdownGroupsContainer = $wrapper.find( '.form-variable__groups' );
	}

	createFilter(){
		// Check if it's a field that should filter tokens
		if ( this.shouldSupportFilters() ){
			// Get the field type
			const fieldType = this.Field.attributes.fieldType;

			// Get the field type human-readable name
			const fieldTypeHumanReadable = isDefined( UncannyAutomator._core.i18n.tokens.tokenType[ fieldType ] ) ? UncannyAutomator._core.i18n.tokens.tokenType[ fieldType ] : fieldType;

			// Create filter container
			const $filterContainer = $( `
				<div class="form-variable__filter"></div>
			` );

			// Create checkbox
			const filterToggle = new Field( 'checkbox', {
				optionCode:   'token__enableFilter',
				currentValue: true,
				label: `<span class="form-variable__filter-label">` + sprintf( UncannyAutomator._core.i18n.tokens.filter, `<span class="form-variable__filter-type">${ fieldTypeHumanReadable }</span>` ) + `<span>`,
			});

			// Get checkbox form element
			const $filterFormElement = filterToggle.createFormElement();

			// Add the field
			$filterContainer.prepend( $filterFormElement );

			// Add filter to the DOM
			this.$elements.searchFieldContainer.append( $filterContainer );

			// Save the filter container
			this.$elements.filterContainer = $filterContainer;

			// Listen changes to the checkbox value
			$filterFormElement.on( 'automator:field:change', () => {
				// Get value
				const filterValue = filterToggle.getValue();

				// Check if we have to filter or remove the filter
				if ( filterValue ){
					this.setFilter( true );
				}
				else {
					this.setFilter( false );
				}
			});
		}    
	}

	createGroupsOfTokens(){
		// Get the container
		const $container = this.$elements.wrapper.find( '.form-variable__groups' );

		// Get all tokens but the ones coming from actions
		const nonItemTokens  = this.tokens.filter( tokenGroup => ! isDefined( tokenGroup.itemType ) );
		const triggersTokens = this.tokens.filter( tokenGroup => tokenGroup.itemType === 'trigger' );
		const actionTokens   = this.tokens.filter( tokenGroup => tokenGroup.itemType === 'action' );

		nonItemTokens.forEach(( groupOfTokens, groupKey ) => {
			$container.append( this.createIndividualGroupOfTokens( groupKey, groupOfTokens ) );
		});

		// Check if it has trigger tokens
		if ( triggersTokens.length > 0 ) {
			$container.get(0).insertAdjacentHTML( 'beforeEnd', `
				<uo-alert 
					size="xsmall" 
					type="info" 
					custom-icon 
					no-radius

					class="form-variable__group-item-separator form-variable__group-item-separator--triggers"
				>
					${ UncannyAutomator._core.i18n.trigger.name }
				</uo-alert>
			` );

			triggersTokens.forEach(( groupOfTokens, groupKey ) => {
				$container.append( this.createIndividualGroupOfTokens( groupKey, groupOfTokens ) );
			});
		}

		if ( actionTokens.length > 0 ) {
			$container.get(0).insertAdjacentHTML( 'beforeEnd', `
				<uo-alert 
					size="xsmall" 
					type="info" 
					custom-icon 
					no-radius

					class="form-variable__group-item-separator form-variable__group-item-separator--actions"
				>
					${ UncannyAutomator._core.i18n.action.name }
				</uo-alert>
			` );

			actionTokens.forEach(( groupOfTokens, groupKey ) => {
				$container.append( this.createIndividualGroupOfTokens( groupKey, groupOfTokens ) );
			});
		}

		// Save all the groups
		this.$elements.allGroups = $container.find( '.form-variable__group' );

		// Save all the items
		this.$elements.dropdownTokens = $container.find( '.form-variable__group-item' );

		// Get separators
		this.$elements.separators = {
			triggers: $container.get(0).querySelector( '.form-variable__group-item-separator--triggers' ),
			actions:  $container.get(0).querySelector( '.form-variable__group-item-separator--actions' ),
		};

		// Add the "no results" option
		this.$elements.noResultsOption = $( `
			<div class="form-variable__group-item-no-results form-variable__group-item-no-results--hide">
				<div class="form-variable__group-item-no-results-title">
					${ UncannyAutomator._core.i18n.tokens.noResults }
				</div>
				<div class="form-variable__group-item-no-results-description">
					${ this.shouldSupportFilters() ? UncannyAutomator._core.i18n.tokens.noResultsDescriptionWithFilter : UncannyAutomator._core.i18n.tokens.noResultsDescription }
				</div>
			</div>
		` );
		$container.append( this.$elements.noResultsOption );
	}

	createIndividualGroupOfTokens( groupKey, groupOfTokens ){
		const $group = $( `
			<div 
				class="form-variable__group"
				data-id="${ groupOfTokens.id }"
			>
				<div class="form-variable__group-source">
					<div class="form-variable-group-source__icon"></div>
					<div class="form-variable-group-source__description">
						<div class="form-variable-group-source__title"></div>
						<div class="form-variable-group-source__tags"></div>
					</div>
					<div class="form-variable-group-source__toggle">
						<span class="form-variable-group-source__toggle-icon"></span>
					</div>
				</div>
				<span class="form-variable__group-children"></span>
			</div>
		` );

		// Add the name
		const groupName = parseDynamicSentence( {
			itemID: this.Field.attributes.itemId,
			dynamicSentence: groupOfTokens.name,
			fields: isDefined( UncannyAutomator.recipe.items[ groupOfTokens.itemID ] ) ? UncannyAutomator.recipe.items[ groupOfTokens.itemID ].meta : {},
			abbreviateFields: true
		} );

		$group
			.find( '.form-variable-group-source__title' )
			.append( groupName );

		// Create the icon
		let $icon = groupOfTokens.icon.cloneNode();

		// Add the icon to the group
		$group.find( '.form-variable-group-source__icon' ).append( $icon );

		// Get the toggle button
		const $toggleButton = $group.find('.form-variable__group-source');

		// Function to send custom event based on the group's state
		const sendGroupToggleEvent = ( isOpen ) => {
			const eventName = isOpen 
				? 'uap/builder/legacy/field/token-selector/group/close' 
				: 'uap/builder/legacy/field/token-selector/group/open';

			// Send custom event to the document
			document.dispatchEvent( new CustomEvent( eventName, {
				detail: {
					groupCode: groupOfTokens.id
				}
			} ) );
		};

		// Listen for clicks on the toggle button
		$toggleButton.on( 'click', () => {
			const isOpen = $group.hasClass( 'form-variable__group--open' );
			
			// Send the appropriate custom event
			sendGroupToggleEvent( isOpen );
			
			// Toggle the open class on the group
			$group.toggleClass( 'form-variable__group--open' );
		} );

		// Check if it's an action that's delayed, scheduled or inside a conditions block
		if ( 
			isDefined( groupOfTokens.itemID ) && 
			isDefined( UncannyAutomator.recipe.items[ groupOfTokens.itemID ] )
		) {
			if (
				UncannyAutomator.recipe.items[ groupOfTokens.itemID ].itemType === 'trigger'
			) {
				// Add class to get these groups later
				$group.get(0).classList.add( 'form-variable__group--trigger' );
			}

			if ( 
				UncannyAutomator.recipe.items[ groupOfTokens.itemID ].itemType === 'action'
			) {
				// Get the wrapper of the tags
				const $tagsWrapper = $group.get(0).querySelector( '.form-variable-group-source__tags' );

				// Get the itme of the FIELD. This is where we're adding the token
				const fieldItemID = this.Field.attributes.itemId;

				// Get action of the TOKEN. This is where the token is coming from
				const tokenAction = UncannyAutomator.recipe.items[ groupOfTokens.itemID ];

				// Add class to get these groups later
				$group.get(0).classList.add( 'form-variable__group--action' );

				if ( tokenAction.hasConditions ) {
					$group.get(0).classList.add( 'form-variable__group--action-conditions' );

					$tagsWrapper.insertAdjacentHTML( 'beforeEnd', `
						<uo-tooltip>
							${ UncannyAutomator._core.i18n.conditions.hasConditionsTokensDisclaimer }

							<uo-chip
								size="small"
								color="warning"
								filled

								slot="target"
							>
								<uo-icon id="code-merge"></uo-icon> ${ UncannyAutomator._core.i18n.conditions.hasConditions }
							</uo-chip>
						</uo-tooltip>
					` );
				}

				// Check if we're adding this token to an action
				if (
					isDefined( fieldItemID ) && 
					isDefined( UncannyAutomator.recipe.items[ fieldItemID ] ) && 
					UncannyAutomator.recipe.items[ fieldItemID ].itemType === 'action'
				) {
					// Get the field action
					const fieldItem = UncannyAutomator.recipe.items[ fieldItemID ];

					// Check if the action where the token is coming from is scheduled, BUT THE DESTINATION action is not
					// This means the token MIGHT not be available
					if ( tokenAction.isScheduled && ! fieldItem.isScheduled ) {
						$group.get(0).classList.add( 'form-variable__group--action-scheduled' );

						$tagsWrapper.insertAdjacentHTML( 'beforeEnd', `
							<uo-tooltip>
								${ UncannyAutomator._core.i18n.tokens.isScheduledTokensDisclaimer }

								<uo-chip
									size="small"
									color="warning"
									filled

									slot="target"
								>
									<uo-icon id="clock"></uo-icon> ${ UncannyAutomator._core.i18n.tokens.isScheduled }
								</uo-chip>
							</uo-tooltip>
						` );
					}
					
					if ( ( tokenAction.isDelayed && ! fieldItem.isDelayed ) || ( tokenAction.isDelayedCustom && ! fieldItem.isDelayedCustom ) ) {
						$group.get(0).classList.add( 'form-variable__group--action-delayed' );

						$tagsWrapper.insertAdjacentHTML( 'beforeEnd', `
							<uo-tooltip>
								${ UncannyAutomator._core.i18n.tokens.isDelayedTokensDisclaimer }

								<uo-chip
									size="small"
									color="warning"
									filled

									slot="target"
								>
									<uo-icon id="clock"></uo-icon> ${ UncannyAutomator._core.i18n.tokens.isDelayed }
								</uo-chip>
							</uo-tooltip>
						` );
					}
				}
			}
		}

		// Get the container where we're going to add the tokens
		const $tokensListContainer = $group.find( '.form-variable__group-children' );

		// Add tokens
		groupOfTokens.tokens.forEach(( token ) => {
			// Check if the token is deprecated
			if ( isDefined( token.deprecated ) && token.deprecated ) {
				return false;
			}

			let tokenName = ! isEmpty( token.name ) ? token.name : '';

			// Create the token
			const $token = $( `
				<div 
					class="form-variable__group-item"
					data-search="${
						tokenName
							.trim()
							.toLowerCase()
							.replace( /\s/g, '' )
					}"
					data-type="${ token.type }"
					data-token-id="${ token.id }"
				>
					<span>${ tokenName }</span>

					${ ( ! this.itemIsInsideUserLoop ) && UncannyAutomator._recipe.recipe_type == 'anonymous' && ! UncannyAutomator.recipe.requiresUserData && isDefined( token.requiresUser ) && token.requiresUser ? '<span class="form-variable__group-item-tag">' + UncannyAutomator._core.i18n.needsUserData + '</span>' : '' }
				</div>
			` );

			/**
			 * Callback invoked to add the token to the field
			 * 
			 * @return {undefined}
			 */
			const addTokenToField = ( token ) => {
				// Trigger event to add the token
				this.Field.field.trigger( 'ua-add-token', token );

				// Send custom event to the document
				document.dispatchEvent( new CustomEvent( 'uap/builder/legacy/field/token-selector/token/add', {
					detail: {
						field: this.Field,
						$field: this.Field.field,
						tokenCode: token.id
					}
				} ) );
			}

			// Listen clicks to the tokens
			$token.on( 'click', () => {
				// Close the token selector
				this.close( {
					triggeredBy: 'token-added'
				} );

				// Check if the beforeAdded callback is defined for this token
				if ( isDefined( token.beforeAdded ) ) {
					// Invoke custom method
					token.beforeAdded( addTokenToField, this.Field );
				} else {
					addTokenToField( token );
				}
			});

			// Add token
			$tokensListContainer.append( $token );
		});

		this.tokens[ groupOfTokens.order ].$toggleButton = $toggleButton;

		return $group;
	}

	addAllTokensInGroupCallback( groupOfTokens ) {
		// Create the content for the modal
		const $modalContent = $( `<div></div>` );

		// Create the "Include name" field
		const includeTokenNameField = new Field( 'checkbox', {
			label: UncannyAutomator._core.i18n.tokens.includeTokenName,
			currentValue: true
		});
		// Add the field
		$modalContent.append( includeTokenNameField.createFormElement() );

		// Create the "Include token ID" field
		const includeTokenIDField = new Field( 'checkbox', {
			label: UncannyAutomator._core.i18n.tokens.includeTokenID,
			currentValue: false
		});
		// Add the field
		$modalContent.append( includeTokenIDField.createFormElement() );

		// Add description
		const groupName = groupOfTokens.name instanceof jQuery ? groupOfTokens.name.text() : groupOfTokens.name;

		const $taskDescription = $( `<div class="description">${
			sprintf(
				UncannyAutomator._core.i18n.tokens.addAllDescription,
				groupName,
				! isEmpty( this.Field.attributes.label ) ? this.Field.attributes.label : UncannyAutomator._core.i18n.noLabel
			)
		}</div>` );
		$modalContent.append( $taskDescription );

		// Show a modal
		const modal = new Modal({
			title: UncannyAutomator._core.i18n.tokens.addTokens,
			content: $modalContent,
			buttons: {
				cancel:  UncannyAutomator._core.i18n.cancel,
				confirm: UncannyAutomator._core.i18n.tokens.addTokens,
			}
		});

		modal.setEvents({
			onConfirm: () => {
				// Try to add all tokens
				try {
					// Close the token selector
					this.close( {
						triggeredBy: 'token-added'
					} );

					// Get the value of the fields
					const hasToIncludeName = includeTokenNameField.getValue(),
					      hasToIncludeID   = includeTokenIDField.getValue();

					// Get the current value of the field
					const currentFieldValue = this.Field.getValue();

					// Create string where we're going to save the output of the tokens
					let tokenContent = '';

					// Iterate tokens
					groupOfTokens.tokens.forEach( ( token ) => {
						// Check if the token is deprecated
						if ( isDefined( token.deprecated ) && token.deprecated ) {
							return false;
						}

						// Add name
						if ( hasToIncludeName ) {
							tokenContent += `${ token.name }`;
						}

						// Add the token ID
						if ( hasToIncludeID ) {
							if ( hasToIncludeName ) {
								tokenContent += ' ';
							}
							
							tokenContent += `(${ token.id })`;
						}

						// Add colon
						if ( hasToIncludeName || hasToIncludeID ) {
							tokenContent += `: `;
						}

						// Add the token
						tokenContent += `{{${ token.id }}}`;

						// Add a breakline (only if the field is Textarea)
						if ( this.Field.type == 'textarea' ) {
							tokenContent += '<br><br>';
						} else {
							// Otherwise, add a separator
							tokenContent += ' | ';
						}
					} );

					// Add it to the current token of the field
					// This behavior changes if we're adding it to a textarea with TinyMCE
					// Check if it's a TinyMCE textarea with an HTML template
					if (
						this.Field.type == 'textarea' && 
						isDefined( this.Field.fieldTinyMCE ) && 
						currentFieldValue.includes( '</body>' )
					) {
						try {
							// Add it before the closing body tag
							this.Field.setValue( currentFieldValue.replace( '</body>', `${ tokenContent }</body>` ) );
						} catch ( e ) {
							// It's a normal field or a plain-text textarea
							// Add it at the end
							this.Field.setValue( `${ currentFieldValue } ${ tokenContent }` );
						}
					} else {
						// It's a normal field or a plain-text textarea
						// Add it at the end
						this.Field.setValue( `${ currentFieldValue } ${ tokenContent }` );
					}

					// Check if it's a textarea using the "Visual" view
					if ( this.Field.type == 'textarea' && isDefined( this.Field.fieldTinyMCE ) && ! this.Field.fieldTinyMCE.hidden ) {
						// Trigger change to render tokens
						this.Field.getField().trigger( 'ua-tinymce-activate-visual-view' );
					}
				} catch ( e ) {
					// Output error if the developer mode is enabled
					if ( UncannyAutomator._site.has_debug_enabled ){
						// eslint-disable-next-line no-console
						console.warn( e );
					}

					alert( `Debugging: Couldn't add all tokens. Enable debug mode and check the console.` );
				}

				// Destroy the modal
				modal.destroy();
			},
			afterHide: function(){
				modal.destroy();
			}
		});
	}

	listenToggleButton(){
		this.$elements.toggleButton.on( 'click', () => {
			// Check if it's NOT open
			if ( ! this.data.isOpen ){
				this.open();
			}
			else {
				this.close( {
					triggeredBy: 'toggle-button'
				} );
			}
		});
	}

	search(){
		// Listen changes to the search field
		this.$elements.searchField.on( 'input', throttle( () => {
			// Get the value
			let query = this.$elements.searchField.val();

			// Remove spaces and make the query lowercase
			query = query
				.trim()
				.toLowerCase()
				.replace( /\s/g, '' );

			if ( ! isEmpty( query ) ){
				// Open all groups of tokens
				this.$elements.allGroups
					.addClass( 'form-variable__group--open' );

				// Hide all elements
				this.$elements.dropdownTokens
					.addClass( 'form-variable__group-item--hidden-by-search' );

				// Get search matches
				const $searchMatches = this.$elements.dropdownTokens
					.filter(( i, token ) => {
						return token.dataset.search.search( query ) !== -1
					}
				);

				// Show the search matches
				$searchMatches
					.removeClass( 'form-variable__group-item--hidden-by-search' );
			}
			else {
				// Close all groups
				this.$elements.allGroups
					.removeClass( 'form-variable__group--open' );

				// Show all tokens
				this.$elements.dropdownTokens
					.removeClass( 'form-variable__group-item--hidden-by-search' );
			}

			// Set the visibility of the group of tokens
			this.updateGroupsOfTokensVisibility();
		}, 30 ) );

		this.$elements.searchField.on( 'focus', () => {
			this.$elements.wrapper.addClass( 'form-variable--search-focus' );
		} );

		this.$elements.searchField.on( 'blur', () => {
			this.$elements.wrapper.removeClass( 'form-variable--search-focus' );
		} );
	}

	setFilter( filterByType = true ){
		// Check if we have to filter
		if ( filterByType ){
			// Hide all elements
			this.$elements.dropdownTokens
				.addClass( 'form-variable__group-item--hidden-by-filter' );

			// Get the tokens by type
			const $tokensByType = this.$elements.dropdownTokens
				.filter(( i, token ) => {
					// Check if the field is a "float" field. In that case,
					// promote all the "int" tokens to "float". All integers
					// are floats
					const tokenType = ( token.dataset.type == 'int' && this.Field.attributes.fieldType == 'float' ) ? 'float' : token.dataset.type;

					// Return the tokens that match the field type
					return tokenType == this.Field.attributes.fieldType;
				}
			);

			// Show the tokens that match the field type
			$tokensByType
				.removeClass( 'form-variable__group-item--hidden-by-filter' );
		}
		else {
			// Show all tokens
			this.$elements.dropdownTokens
				.removeClass( 'form-variable__group-item--hidden-by-filter' );
		}

		// Set the visibility of the group of tokens
		this.updateGroupsOfTokensVisibility();
	}

	updateGroupsOfTokensVisibility(){
		// this.$elements.allGroups
			// .removeClass( 'form-variable__group--open' );

		// Create the variable that we will use to evaluate
		// if there are available tokens
		let hasResults = false;

		// Show all the groups of tokens
		this.$elements.allGroups
			.removeClass( 'form-variable__group--without-available-tokens' );

		// Hide the group of tokens that don't have available tokens
		this.$elements.allGroups
			.filter(( i, group ) => {
				// Check if the group has available tokens
				const groupHasAvailableTokens = group
					.querySelectorAll( '.form-variable__group-item:not(.form-variable__group-item--hidden-by-filter):not(.form-variable__group-item--hidden-by-search)' )
					.length > 0;

				// If it doesn't have available tokens, then hide the group
				if ( ! groupHasAvailableTokens ){
					group.classList.add( 'form-variable__group--without-available-tokens' );
				}
				else {
					// The group has available tokens, update "hasResults"
					hasResults = true;
				}
			}
		);

		// Check if there are available tokens at all
		if ( hasResults ){
			this.$elements.noResultsOption
				.addClass( 'form-variable__group-item-no-results--hide' );

			// Check if we have to show or hide the separators
			if ( this.$elements.separators.triggers ) {
				// Check if tokens from triggers
				if ( this.$elements.allGroups.filter( '.form-variable__group--trigger:not(.form-variable__group--without-available-tokens)' ).length === 0 ) {
					this.$elements.separators.triggers.classList.add( 'form-variable__group-item--hidden-by-search' );
				} else {
					this.$elements.separators.triggers.classList.remove( 'form-variable__group-item--hidden-by-search' );
				}
			}

			// Check if we have to show or hide the separators
			if ( this.$elements.separators.actions ) {
				// Check if tokens from actions
				if ( this.$elements.allGroups.filter( '.form-variable__group--action:not(.form-variable__group--without-available-tokens)' ).length === 0 ) {
					this.$elements.separators.actions.classList.add( 'form-variable__group-item--hidden-by-search' );
				} else {
					this.$elements.separators.actions.classList.remove( 'form-variable__group-item--hidden-by-search' );
				}
			}
		}
		else {
			this.$elements.noResultsOption
				.removeClass( 'form-variable__group-item-no-results--hide' );

			if ( this.$elements.separators.triggers ) { this.$elements.separators.triggers.classList.add( 'form-variable__group-item--hidden-by-search' ); }
			if ( this.$elements.separators.actions ) { this.$elements.separators.actions.classList.add( 'form-variable__group-item--hidden-by-search' ); }
		}
	}

	open(){
		// If it's a date or time field, try to close
		// the calendar
		if ( [ 'date', 'time' ].includes( this.Field.attributes.fieldType ) ){
			try {
				this.Field.flatpickrInstance.close();
			} catch ( e ){
				// Continue regardless of error
		
				// Output error if the developer mode is enabled
				if ( UncannyAutomator._site.has_debug_enabled ){
					// eslint-disable-next-line no-console
					console.warn( e );
				}
			}
		}

		// Add open class
		this.$elements.wrapper.addClass( 'form-variable--open' );

		// Save status
		this.data.isOpen = true;

		// Listen clicks outside the token selector and close it
		this.closeWhenClickedOutside();

		// Reset the search field (remove the value)
		this.$elements.searchField
			.val( '' )
			.trigger( 'input' )
			// Set padding of the search field depending on the width
			// of the checkbox label
			.css({
				'padding-right': `${ ( ( isDefined( this.$elements.filterContainer ) ? this.$elements.filterContainer.outerWidth() : 0 ) + 12 ) }px`
			});;

		// Focus the search field
		this.$elements.searchField
			.focus();

		// Determine view (default/bubble)
		this.setDropdownView();
								
		// Determine direction of the selector
		this.setDropdownDirection();

		// Set scroll
		this.setDropdownHeight();

		// Create the custom context menus
		this.addContextMenus();

		// Send custom event to the document
		document.dispatchEvent( new CustomEvent( 'uap/builder/legacy/field/token-selector/open', {
			detail: {
				fieldCode: this.Field.attributes.optionCode
			}
		} ) );
	}

	addContextMenus() {
		// Iterate the groups of tokens
		this.tokens.forEach(( groupOfTokens, groupKey ) => {
			// Create custom context menu for debugging
			try {
				const contextMenu = new uap.ContextMenu( {
					id: 'tokens',
					$element: groupOfTokens.$toggleButton[0]
				} );

				// Save it
				this.tokens[ groupKey ].contextMenu = contextMenu;

				// Add a group
				const debuggingGroup = contextMenu.addGroup( {
					id: 'testing',
					name: UncannyAutomator._core.i18n.debuggingTools
				} );

				// Add a different context for the "Advanced" group
				if ( groupOfTokens.id == 'advanced' ) {
					// Add the items
					debuggingGroup.addItem( {
						id: 'add-all-tokens',
						name: UncannyAutomator._core.i18n.tokens.addAllTokensInGroup,
						disabled: true
					} );
				} else {
					// Add the items
					debuggingGroup.addItem( {
						id: 'add-all-tokens',
						name: UncannyAutomator._core.i18n.tokens.addAllTokensInGroup,
						callback: () => { this.addAllTokensInGroupCallback( groupOfTokens ) }
					} );
				}
			} catch ( e ){
				// Output error if the developer mode is enabled
				if ( UncannyAutomator._site.has_debug_enabled ){
					// eslint-disable-next-line no-console
					console.warn( e );
				}
			}
		});
	}

	close( { triggeredBy = 'unknown' } ){
		this.$elements.wrapper.removeClass( 'form-variable--open' );

		// Save status
		this.data.isOpen = false;

		// Rest input value and trigger 'input' event
		this.$elements.searchField
			.val( '' )
			.trigger( 'input' );

		// Stop listening clicks outside the token selector
		$( document ).off( 'mouseup.uap-token-selector-click-outside' );

		// Iterate the groups and remove the context menus
		this.tokens.forEach(( groupOfTokens, groupKey ) => {
			try {
				// Destroy ContextMenu
				groupOfTokens.contextMenu.destroy();
			} catch ( e ) {
				// Output error if the developer mode is enabled
				if ( UncannyAutomator._site.has_debug_enabled ){
					// eslint-disable-next-line no-console
					console.warn( e );
				}
			}
		} );

		// Send custom event to the document
		document.dispatchEvent( new CustomEvent( 'uap/builder/legacy/field/token-selector/close', {
			detail: {
				fieldCode: this.Field.attributes.optionCode,
				triggeredBy: triggeredBy
			}
		} ) );
	}

	destroy(){
		// Remove all the elements but the original field
		this.$elements.renderContainer.children().insertAfter( this.$elements.wrapper );
		this.$elements.wrapper.remove();
	}

	closeWhenClickedOutside(){
		$( document ).on( 'mouseup.uap-token-selector-click-outside', ( event ) => {
			// Set the targetted container
			const $container = this.$elements.wrapper;

			if ( ! $container.is( event.target ) && $container.has( event.target ).length === 0 ){
				// Hide
				this.close( {
					triggeredBy: 'click-outside'
				} );
			}
		});
	}

	getDropdownPosition(){
		const $window = $( window );

		const position = {}
		position.above = this.$elements.wrapper.offset().top - $window.scrollTop();
		position.below = $window.height() - ( position.above + this.$elements.wrapper.outerHeight() );

		// Check if the current field is a textarea
		if ( this.Field.type == 'textarea' ){
			// Recalculate the space below
			position.below = $window.height() - ( position.above + 38 );
		}

		// Add "real size" class. We're using this to
		// get the real size of the dropdown
		this.$elements.dropdown.addClass( 'uo-realsize' );
		// Get the dropdown height
		const dropdownHeight = this.$elements.dropdown.outerHeight() + 110; // + 75px to show at least 1 option
		this.$elements.dropdown.removeClass( 'uo-realsize' );

		// Show dropdown always below for textareas
		if ( this.Field.type == 'textarea' ){
			position.hasSpaceBelow = true;
		}
		else {
			position.hasSpaceBelow = position.below >= dropdownHeight;
		}

		return position;
	}

	setDropdownView() {
		if ( this.$elements.dropdown.width() < 350 ) {
			// Set the "bubble" view
			this.$elements.wrapper.addClass( 'form-variable--bubble' );
		}
	}

	setDropdownDirection(){
		// Get the position of the dropdown
		const position = this.getDropdownPosition();

		// Remove the position classes
		this.$elements.wrapper.removeClass( 'form-variable--above form-variable--below' );

		// Determine the position
		if ( position.below > position.above || position.hasSpaceBelow ){
			// Let's show it below
			this.$elements.wrapper.addClass( 'form-variable--below' );

			// Save the position
			this.data.position = 'below';
		}
		else {
			// Let's show it above
			this.$elements.wrapper.addClass( 'form-variable--above' );

			// Save the position
			this.data.position = 'above';
		}
	}

	setDropdownHeight(){
		// Check if it's open
		if ( this.data.isOpen ){
			// Get the max height of the dropdown
			const maxHeight = this.getDropdownPosition()[ this.data.position ] - this.$elements.searchField.outerHeight() - 45;

			// Set the max height
			this.$elements.dropdownGroupsContainer
				.css({ 
					'max-height' : `${ maxHeight }px`
				});
		}
	}

	focusSearchField(){
		this.$elements.searchField
			.focus();
	}

	resizeDropdownOnWindowResize(){
		$( window ).on( 'resize', 
			throttle( () => {
				// Determine direction of the selector
				this.setDropdownDirection();

				// Set height
				this.setDropdownHeight();
			}, 20 )
		);
	}

	resizeDropdownOnWindowScroll(){
		$( window ).on( 'scroll', 
			debounce( () => {
				// Determine direction of the selector
				this.setDropdownDirection();

				// Set height
				this.setDropdownHeight();
			}, 300 )
		);
	}

	refreshOnFieldChange(){
		// CodeMirror methods
		this.Field.formElement.on( 'automator:field:change', () => {
			// Determine direction of the selector
			this.setDropdownDirection();

			// Set height
			this.setDropdownHeight();
		});
	}

	shouldSupportFilters(){
		// Get the field type
		const fieldType = this.Field.attributes.fieldType;

		return [ 'email', 'int', 'float', 'url', 'date', 'time' ].includes( fieldType );
	}
}